module.exports = __webpack_public_path__ + "img/convenience-store.3aaa0eb4.jpg";